import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../../services/apiService";

const GET_ACQUIRER_LIST = "acquirer/getList";

export const getAcquirerList = createAsyncThunk(
  GET_ACQUIRER_LIST,
  async (payload, { rejectWithValue, dispatch }) => {
    const { token, ...rest } = payload;
    const url = "/acquirer";
    try {
      const params = {
        ...rest,
      };
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const { data, page, page_size, total_pages, total_records } = await get(
        url,
        config
      );

      return {
        acquirerData: data,
        page,
        page_size,
        total_pages,
        total_records,
      };
    } catch (error) {
      console.error("Error fetching enrollment data thunk:", error);
      return rejectWithValue(error.response.data);
    }
  }
);
